import { render, staticRenderFns } from "./denglu.vue?vue&type=template&id=612ee12d&scoped=true"
import script from "./denglu.vue?vue&type=script&lang=js"
export * from "./denglu.vue?vue&type=script&lang=js"
import style0 from "./denglu.vue?vue&type=style&index=0&id=612ee12d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612ee12d",
  null
  
)

export default component.exports